var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnchargeLogoLetter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00195312 15.8879C0.00506729 12.105 1.47269 8.46091 4.11523 5.67304C6.75778 2.88517 10.3827 1.15653 14.2773 0.827336C18.172 0.49814 22.0542 1.59234 25.1562 3.89464C28.2583 6.19695 30.3562 9.53966 31.0371 13.2648H15.5801L22.8301 9.2355L21.4004 8.22251C19.7156 7.03475 17.6821 6.39813 15.5977 6.40443C13.5132 6.41073 11.4856 7.06049 9.80859 8.25842C8.13154 9.45634 6.89365 11.1406 6.27344 13.0663C5.65323 14.992 5.68258 17.0588 6.35938 18.9666C7.03617 20.8743 8.32538 22.5232 10.0371 23.6743C11.7488 24.8254 13.7951 25.4171 15.8789 25.3658C17.9627 25.3145 19.974 24.6228 21.623 23.389C23.2721 22.1551 24.4732 20.444 25.0488 18.5055H31.0352C30.3569 22.2322 28.2601 25.5787 25.1582 27.8831C22.0563 30.1875 18.1752 31.2828 14.2793 30.9542C10.3834 30.6256 6.75642 28.8956 4.11328 26.1066C1.47015 23.3177 0.00176467 19.672 0 15.8879H0.00195312Z",
    fill: "#3B3B3B"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnchargeLogoLetter);
export default __webpack_public_path__ + "static/media/encharge-logo-letter.462a90b6.svg";
export { ForwardRef as ReactComponent };